import React, { useState, useEffect } from 'react';
import './Checkout.scss';
import { useNavigate } from 'react-router-dom';
import { miniApp } from '@telegram-apps/sdk-react';
import { useCart } from '../../contexts/CartContext';
import { useBackButtonManager } from '../../contexts/BackButtonContext';
import LoaderBlock from '../../components/ui/LoaderBlock';
import { useCurrency } from '../../contexts/CurrencyContext';
import api from "../../api";
import qs from 'qs';
import ApiImage from '../../components/ApiImage';
import DeliveryIcon from '../../components/ui/DeliveryIcon';
import isEmpty from '../../utils/isEmpty';
import { useToast } from "../../contexts/ToastContext";
import { useUser } from "../../contexts/UserContext";
import Button from '../../components/ui/Button';

function Checkout() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { action, clear } = useBackButtonManager();
  const { user, isLoading, reloadUser } = useUser();
  
  const {
      setIsCartOpen,
      setIsEnable,
      cartItems,
      openModal,
      clearCart
    } = useCart();
  const { cny, usd, courseDate } = useCurrency();
  const [deliveryOptions, setDeliveryOptions] = useState([]);
  const [packagingOptions, setPackagingOptions] = useState([]);
  const [isLoad, setIsLoad] = useState(true);
  const [products, setProducts] = useState([]);
  const [pickIndex, setPickIndex] = useState(null);
  const [pickPackIndex, setPickPackIndex] = useState(null);
  const [fio, setFio] = useState("");
  const [city, setCity] = useState("");
  const [phone, setPhone] = useState("");
  const [comment, setComment] = useState("");
  const formattedDate = new Date(courseDate).toLocaleDateString('ru-RU');
  useEffect(() => {
    miniApp.setBackgroundColor('#161618');
    miniApp.setHeaderColor('#161618');
    setIsEnable(false);
    setIsCartOpen(false);
    clear();
    action(() => window.history.back());
    setIsLoad(true);
    const fetchProduct = async () => {
        try {
            const ids = cartItems.map(item => item.id);
            const response = await api.get('/api/products/UserProductsCart', {
              params: { id: ids },
              paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
            });
            const data = response.data;
            setProducts(data);
            setIsLoad(false);
        } catch (error) {
            console.error("Ошибка при загрузке товаров:", error);
        }
    };
    const fetchDelivery = async () => {
        try {
            const response = await api.get('/api/deliveries');
            const data = response.data;
            setDeliveryOptions(data);
            setIsLoad(false);
        } catch (error) {
            console.error("Ошибка при загрузке товаров:", error);
        }
    };
    const fetchProductPackages = async () => {
        try {
            const response = await api.get('/api/productPackages');
            const data = response.data;
            setPackagingOptions(data);
            setIsLoad(false);
        } catch (error) {
            console.error("Ошибка при загрузке товаров:", error);
        }
    };
    fetchProduct();
    fetchDelivery();
    fetchProductPackages();
    setFio(user?.fio);
    setCity(user?.city);
    setPhone(user?.phone);

    return () => {
      miniApp.setBackgroundColor('#1D1D20');
      miniApp.setHeaderColor('#1D1D20');
      setIsEnable(true);
      clear();
    };
  }, []);

  const totalPriceY = cartItems.reduce((sum, cartItem) => {
    const product = products.find(p => p.id === cartItem.id);
    if (!product) return sum;
    return (sum + Math.round((product.cost)) * cartItem.quantity);
  }, 0);

  const totalPriceRub = cartItems.reduce((sum, cartItem) => {
    const product = products.find(p => p.id === cartItem.id);
    if (!product) return sum;
    return (sum + Math.round((product.cost * cny)) * cartItem.quantity);
  }, 0);

  const deliveryActive = deliveryOptions.find(p => p.id == pickIndex);
  const packageActive = packagingOptions.find(p => p.id == pickPackIndex);

  const totalDelivery = (id) => {
    if (id == null) return 0;
    let total = 0;

    products.forEach(product => {
      const quantity = cartItems.find(ci => ci.id === product.id)?.quantity ?? 1;
      const matchingDelivery = product.deliveries?.find(d => d.deliveryRate === id);
      if (matchingDelivery) {
        total += matchingDelivery.cost * quantity;
      }
    });

    return total;
  }

  const totalRub = (id) => {
    let total = 0;
    let totalDelivery = 0;

    if (id != null) {
      products.forEach(product => {
        const quantity = cartItems.find(ci => ci.id === product.id)?.quantity ?? 1;
        const matchingDelivery = product.deliveries?.find(d => d.deliveryRate === id);
        if (matchingDelivery) {
          totalDelivery += matchingDelivery.cost * quantity;
        }
      });
    }
    
    total = total + (totalDelivery * usd);

    if (packageActive != null) {
      total = total + (packageActive?.cost * usd);
    }

    const _totalPriceRub = cartItems.reduce((sum, cartItem) => {
      const product = products.find(p => p.id === cartItem.id);
      if (!product) return sum;
      return (sum + Math.round((product.cost * cny)) * cartItem.quantity);
    }, 0);

    total = total + _totalPriceRub;

    return Math.round(total);
  }

  const sendCheckout = async () => {
    
    if (isEmpty(fio) || isEmpty(phone) || isEmpty(city)) {
      return showToast(`Заполните поля (ФИО, Телефон, Город)`);
    }

    if (isEmpty(pickIndex)) {
      return showToast(`Выберите способ доставки`);
    }

    if (cartItems.length === 0) {
      return showToast(`Корзина пуста`);
    }
    setIsLoad(true);
    try {
      const orderData = {
        fullName: fio,
        phone: phone,
        city: city,
        comment: comment || null,
        deliveryId: pickIndex,
        productPackageId: pickPackIndex || null, // если используешь сборку
        items: cartItems.map(item => ({
          productId: item.id,
          quantity: item.quantity
        }))
      };

      const response = await api.post('/api/orders/SendOrder', orderData);

      if (response.data?.success) {
        clearCart();
        reloadUser();
        navigate(`/success/order`);
      } else {
        setIsLoad(false);
        showToast(`Ошибка при оформлении заказа`);
      }
    } catch (error) {
      console.error('Ошибка при отправке заказа:', error);
      setIsLoad(false);
      showToast(`Ошибка при оформлении заказа`);
    }
  };


  return (
    <div className="checkout-page page-classes">
      <h2>Оформление заказа</h2>
      <div className="delivery-options">
        <div className="delivery-title">Выберите тип доставки до Москвы</div>
        <div className="delivery-list">
          {deliveryOptions.map((option) => (
            <div className="delivery-item" onClick={() => {setPickIndex(option.id)}} key={option.id}>
              <div className="delivery-info">
                {pickIndex == option.id ? (
                  <div className='select'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#FECA1F"/>
                      <path d="M7.5 12.5994L10.3014 15.0993L16.5 8.90076" stroke="#161618" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                ) : (
                  <div className='select'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1" y="1" width="22" height="22" rx="11" stroke="white" stroke-opacity="0.64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                )}
                
                <div className="delivery-text">
                  <div className="delivery-name">{option.name}</div>
                  <div className="delivery-desc">до {option.day} дней</div>
                </div>
              </div>
              <div className='delivery-price-icon'>
                <div className="delivery-price">
                  <div className='one-price'>{
                    (() => {
                      let total = 0;

                      products.forEach(product => {
                        const quantity = cartItems.find(ci => ci.id === product.id)?.quantity ?? 1;
                        const matchingDelivery = product.deliveries?.find(d => d.deliveryRate === option.id);
                        if (matchingDelivery) {
                          total += matchingDelivery.cost * quantity;
                        }
                      });

                      return `${total.toFixed(2)} $`;
                    })()
                  }</div>
                  <div className='weight-price'>
                    {
                      (() => {
                        let total = 0;

                        products.forEach(product => {
                          const quantity = cartItems.find(ci => ci.id === product.id)?.quantity ?? 1;
                          total += product.weight * quantity;
                        });

                        return `${total.toFixed(2)} кг`;
                      })()
                    }
                  </div>
                </div>
                <div className="delivery-icon"><DeliveryIcon icon={option.icon}></DeliveryIcon></div>
              </div>
              
            </div>
          ))}
        </div>
      </div>
      <div className="delivery-options mt-3">
        <div className="delivery-title">Выберите тип упаковки</div>
        <div className="delivery-list">
          <div className="delivery-item" onClick={() => {setPickPackIndex(null)}}>
              <div className="delivery-info">
                {pickPackIndex == null ? (
                  <div className='select'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#FECA1F"/>
                      <path d="M7.5 12.5994L10.3014 15.0993L16.5 8.90076" stroke="#161618" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                ) : (
                  <div className='select'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1" y="1" width="22" height="22" rx="11" stroke="white" stroke-opacity="0.64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                )}
                <div className="delivery-text">
                  <div className="delivery-name">Не определился</div>
                  <div className="delivery-desc">Менеджер поможет вам</div>
                </div>
              </div>
              <div className='delivery-price-icon'>
              </div>
            </div>
          {packagingOptions.map((option) => (
            <div className="delivery-item" onClick={() => {setPickPackIndex(option.id)}} key={option.id}>
              <div className="delivery-info">
                {pickPackIndex == option.id ? (
                  <div className='select'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#FECA1F"/>
                      <path d="M7.5 12.5994L10.3014 15.0993L16.5 8.90076" stroke="#161618" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                ) : (
                  <div className='select'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="1" y="1" width="22" height="22" rx="11" stroke="white" stroke-opacity="0.64" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                )}
                <div className="delivery-text">
                  <div className="delivery-name">{option.name}</div>
                  <div className="delivery-desc">Цена станет известна после сборки</div>
                </div>
              </div>
              <div className='delivery-price-icon'>
                <div className="delivery-icon"><DeliveryIcon icon={option.icon}></DeliveryIcon></div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='form-box'>
        <div className="form-title">Получатель</div>
        <div className="input-group">
          <input type="text" className="form-control" onChange={(e) => setFio(e.target.value)} value={fio} placeholder="ФИО" />
        </div>
        <div className="input-group">
          <input type="text" className="form-control" onChange={(e) => setCity(e.target.value)} value={city} placeholder="Город" />
        </div>
        <div className="input-group">
          <input type="text" className="form-control" onChange={(e) => setPhone(e.target.value)} value={phone} placeholder="Телефон" />
        </div>
        <div className="input-group">
          <textarea type="text" className="form-control" onChange={(e) => setComment(e.target.value)} value={comment} placeholder="Комментарий"></textarea>
        </div>
      </div>
      <div className='products-box'>
        <div className="form-title">Ваши товары</div>
        {products.map((item) => {
          const cartItem = cartItems.find(ci => ci.id === item.id);
          const quantity = cartItem?.quantity || 0;
          return (
            <div className="cart-item" key={item.id}>
              <div className='cart-main-info'>
                <ApiImage className="item-img" path={item.mainImage}></ApiImage>
                <div className="item-info">
                  <div className="item-price">
                    {Math.round(item.cost * cny)} ₽ <span className="item-cny">≈ {item.cost} ¥</span>
                  </div>
                  <div className="item-name">{item.name}</div>
                  <div className="item-count">{quantity} шт</div>
                </div>
              </div>
            </div>
          )}
        )}
      </div>
      <div className='alert-box'>
        <div className='alert-logo'>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00004 2.66659C5.05452 2.66659 2.66671 5.0544 2.66671 7.99992C2.66671 10.9454 5.05452 13.3333 8.00004 13.3333C10.9456 13.3333 13.3334 10.9454 13.3334 7.99992C13.3334 5.0544 10.9456 2.66659 8.00004 2.66659ZM1.33337 7.99992C1.33337 4.31802 4.31814 1.33325 8.00004 1.33325C11.6819 1.33325 14.6667 4.31802 14.6667 7.99992C14.6667 11.6818 11.6819 14.6666 8.00004 14.6666C4.31814 14.6666 1.33337 11.6818 1.33337 7.99992ZM8.00004 4.66659C8.36823 4.66659 8.66671 4.96506 8.66671 5.33325V8.66659C8.66671 9.03478 8.36823 9.33325 8.00004 9.33325C7.63185 9.33325 7.33337 9.03478 7.33337 8.66659V5.33325C7.33337 4.96506 7.63185 4.66659 8.00004 4.66659ZM7.33337 10.6666C7.33337 10.2984 7.63185 9.99992 8.00004 9.99992H8.00671C8.3749 9.99992 8.67337 10.2984 8.67337 10.6666C8.67337 11.0348 8.3749 11.3333 8.00671 11.3333H8.00004C7.63185 11.3333 7.33337 11.0348 7.33337 10.6666Z" fill="white"/>
          </svg>
        </div>
        <div className='alert-text'>
          <div className='alert-title'>
            Итоговая стоимость не является точной
          </div>
          <div className='alert-description'>
            После оформления заказа с вами свяжется менеджер и уточнит детали по упаковке. Стоимость упаковки оплачивается после получения нами товара на складе в Китае
          </div>
        </div>
      </div>
      <div className='total-box'>
        <table class="price-table">
          <tbody>
            <tr>
              <td className='all'>Сумма товаров</td>
              <td className='alt'>{totalPriceY} ¥</td>
              <td className='amount'>{totalPriceRub} ₽</td>
            </tr>
            <tr>
              <td className='sub'>Доставка</td>
              <td className='alt'>{deliveryActive != null ? (totalDelivery(deliveryActive.id)).toFixed(2) : 0} $</td>
              <td className='amount'>{deliveryActive != null ? (totalDelivery(deliveryActive.id) * usd).toFixed(2) : 0} ₽</td>
            </tr>
            <tr>
              <td className='sub'>Упаковка</td>
              <td className='alt'>~ {packageActive != null ? packageActive?.cost : 0} $</td>
              <td className='amount'>~ {packageActive != null ? (packageActive?.cost * usd) : 0} ₽</td>
            </tr>
          </tbody>
        </table>
        <div className='total-price-container'>
          <div className='total-price'>
            <div className='title-price'>Итого</div>
            <div className='actuality-price'>Актуально на {formattedDate}</div>
          </div>
          <div className='total-price-amount'> ~ {totalRub(deliveryActive?.id)} ₽</div>
        </div>
      </div>
      <div className='btn-container-fixed'>
        <Button onClick={() => {window.history.back()}} className='btn btn-secondary large'>
          Назад
        </Button>
        <Button onClick={sendCheckout} load={isLoad} className='btn btn-primary large'>
          Оформить
        </Button>
      </div>
    </div>
  );
}

export default Checkout;
